import { useCallback, useEffect, useRef } from 'react';
import { RuleListStatus } from '../../../types';
export const useAutoExpandFailedRules = _ref => {
  let {
    items,
    onStatusChange,
    setOpenItems
  } = _ref;
  const prevItemsRef = useRef(items);

  // Find the next failed item after the given item
  const findNextFailedItem = useCallback((itemList, currentIndex) => {
    if (currentIndex === -1) {
      return null;
    }
    for (let i = currentIndex + 1; i < itemList.length; i++) {
      if (itemList[i].status === RuleListStatus.failed) {
        return itemList[i];
      }
    }
    return null;
  }, []);
  useEffect(() => {
    const prevItems = prevItemsRef.current;

    // Check for items that changed from failed to passed
    prevItems.forEach(prevItem => {
      const currentIndex = items.findIndex(item => item.id === prevItem.id);
      if (currentIndex === -1) {
        return;
      }
      const currentItem = items[currentIndex];
      if (prevItem.status === RuleListStatus.failed && currentItem.status === RuleListStatus.passed) {
        // Item changed from failed to passed
        const nextFailedItem = findNextFailedItem(items, currentIndex);
        setOpenItems(prev => {
          const newOpenItems = new Set(prev);
          // Close the current item
          newOpenItems.delete(prevItem.id);
          // Open the next failed item if it exists
          if (nextFailedItem) {
            newOpenItems.add(nextFailedItem.id);
          }
          return newOpenItems;
        });

        // Notify about the status change
        onStatusChange == null || onStatusChange(currentItem, prevItem.status, currentItem.status);
      }
    });

    // Update the ref with current items for next comparison
    prevItemsRef.current = items;
  }, [items, findNextFailedItem, onStatusChange, setOpenItems]);
};
//# sourceMappingURL=use-auto-expand-failed-rules.js.map